import React from "react";
import { connect } from "react-redux";

const StandardFeatures = props => {
  let type = "";
  if (typeof props.type !== "undefined") {
    type = props.type;
  } else {
    type = props.compare.type;
  }
  if (typeof props.compare.nomenclature !== "undefined") {
    if (typeof type === "undefined") type = props.type;

    var nomenclature = props.compare.nomenclature.filter(item => {
      if (item.name === type) return item;
    });
    if (nomenclature.length > 0) nomenclature = nomenclature[0];

    
  }

  const items = nomenclature.standard_features.map(item => {
    var label = <React.Fragment />;
    if (typeof item.label !== "undefined" && item.label !== "") {
      label = <em>{item.label}</em>;
    }
    return (
      <React.Fragment key={item.text}>
        <li style={{display:"flex"}}>
          <span style={{display:"flex"}}>
            <i className="fa fa-check" aria-hidden="true" />
          </span>
          <span>{item.text}</span>
          {label}
        </li>
      </React.Fragment>
    );
  });
  let style = {};

  if (type == "PRO3") style = { width: "100%", marginTop: "10px" };
  else if (type === "CM" || type === "LVCM" || type == "LUC" || type == "MP")
  style = { marginTop: "1px" }; //temp code to be removed once data is fully populated
  return (
    <div style={style} className="brand-features-right">
      <h3>Standard Features</h3>
      <ul>{items}</ul>
    </div>
  );
};
function mapStateToProps(state) {
  return state;
}

export default connect(mapStateToProps)(StandardFeatures);
